import type { Meta, StoryFn } from '@storybook/react';
import type { GridRowProps } from './GridRow';
import type { CSSProperties } from 'react';

import { GridRow } from './GridRow';

import './GridRow.stories.css';

const gapStyles = {
  '0': { '--grid-gap': '0.25rem' },
  '025': { '--grid-gap': '0.25rem' },
  '050': { '--grid-gap': '0.5rem' },
  '075': { '--grid-gap': '0.75rem' },
  '100': { '--grid-gap': '1rem' },
  '125': { '--grid-gap': '1.25rem' },
  '150': { '--grid-gap': '1.5rem' },
  '175': { '--grid-gap': '1.75rem' },
  '200': { '--grid-gap': '2rem' },
  '250': { '--grid-gap': '2.5rem' },
  '300': { '--grid-gap': '3rem' },
  '350': { '--grid-gap': '3.5rem' },
};

const codeString = `
  <GridRow gutter={gutter} marginTop={marginTop} marginBottom={marginBottom}>
    // Up to 12 GridRow.Column's can be added as needed.
    <GridRow.Column size={size} mediumSize={mediumSize} startPositon={startPositon}
      mediumStartPosition={mediumStartPosition}> {children} </GridRow.Column> </GridRow>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Organisms/GridRow',
  component: GridRow,
  argTypes: {
    gutter: {
      options: ['0', '025', '050', '075', '100', '125', '150', '175', '200', '250', '300', '350'],
      control: { type: 'select' },
    },
    marginBottom: {
      options: ['0', '025', '050', '075', '100', '125', '150', '175', '200', '250', '300', '350'],
      control: { type: 'select' },
    },
    marginTop: {
      options: ['0', '025', '050', '075', '100', '125', '150', '175', '200', '250', '300', '350'],
      control: { type: 'select' },
    },
  },
  parameters: {
    inspectComponent: GridRow,
    codeString: codeString,
  },
} as Meta<GridRowProps>;

const Template: StoryFn<GridRowProps> = (args) => (
  <div className="page-wrapper" style={args.gutter && (gapStyles[args.gutter] as CSSProperties)}>
    <GridRow {...args}>
      <GridRow.Column>Col-12</GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="1">Col-1</GridRow.Column>
      <GridRow.Column size="11">Col-11</GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="2">Col-2</GridRow.Column>
      <GridRow.Column size="10">Col-10</GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="3">Col-3</GridRow.Column>
      <GridRow.Column size="9">Col-9</GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="4">Col-4</GridRow.Column>
      <GridRow.Column size="8">Col-8</GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="5">Col-5</GridRow.Column>
      <GridRow.Column size="7">Col-7</GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="6">Col-6</GridRow.Column>
      <GridRow.Column size="6">Col-6</GridRow.Column>
    </GridRow>
  </div>
);

const defaultArgs: Partial<GridRowProps> = {
  gutter: '200',
  marginBottom: '050',
  marginTop: '0',
};

export const GridRowExample = Template.bind({});
GridRowExample.args = {
  ...defaultArgs,
};

const TemplateMedium: StoryFn<GridRowProps> = (args) => (
  <div className="page-wrapper" style={args.gutter && (gapStyles[args.gutter] as CSSProperties)}>
    <GridRow {...args}>
      <GridRow.Column size="4" mediumSize="6">
        L: 4, Md: 6, S: 12
      </GridRow.Column>
      <GridRow.Column size="4" mediumSize="6">
        L: 4, Md: 6, S: 12
      </GridRow.Column>
      <GridRow.Column size="4" mediumSize="12">
        L: 4, Md: 12
      </GridRow.Column>
    </GridRow>
    <GridRow {...args}>
      <GridRow.Column size="3" mediumSize="6">
        L: 3, Md: 6, S: 12
      </GridRow.Column>
      <GridRow.Column size="3" mediumSize="6">
        L: 3, Md: 12
      </GridRow.Column>
      <GridRow.Column size="6" mediumSize="12">
        L: 6, Md: 12, S: 12
      </GridRow.Column>
    </GridRow>
  </div>
);

export const WithMediumBreakpoint = TemplateMedium.bind({});
GridRowExample.args = {
  ...defaultArgs,
};
